import abstractModel from '../../core/MercatelyModel';
import { serializeParams } from '../../util/urlUtils';

const resource = '/api/mia/chatbot/agents';
const csrfToken = document.querySelector('[name=csrf-token]').content;

const model = abstractModel(resource);
const parentGet = model.get;
const parentPut = model.put;

model.get = async (params = {}, newResource = {}) => {
  if (params && typeof params === 'object' && !Array.isArray(params)) {
    const hasArrayParams = Object.values(params).some(value => Array.isArray(value));

    if (hasArrayParams) {
      const queryString = serializeParams(params);
      return parentGet({}, { ...newResource, filters: queryString });
    }
  }

  return parentGet(params, newResource);
};

model.toggleStatus = async (id) => {
  const newResource = `${resource}/${id}/activate`;
  return parentPut({}, { path: newResource, csrfToken });
};

export default model;
